// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/vitrum.scss
// module id = 1295
// module chunks = 147